/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {EntitlementConflictRequest} from '../models/EntitlementConflictRequest';
import type {EntitlementConflictResponse} from '../models/EntitlementConflictResponse';
import type {Error} from '../models/Error';
import type {RelationPage} from '../models/RelationPage';
import type {ResourceType} from '../models/ResourceType';
import type {SortDirection} from '../models/SortDirection';

export interface AccountEntitlementConflictChecker$Request {
    accountId: number;
    entitlementConflictRequest?: EntitlementConflictRequest;
}

export interface AccountEntitlementConflictChecker$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const accountEntitlementConflictCheckerRequest = createAction<PayloadData<void, AccountEntitlementConflictChecker$Request>>('ACCOUNT_ENTITLEMENTS__ACCOUNT_ENTITLEMENT_CONFLICT_CHECKER__REQUEST');
export const accountEntitlementConflictCheckerSuccess = createAction<PayloadData<Array<EntitlementConflictResponse>, AccountEntitlementConflictChecker$Request>>('ACCOUNT_ENTITLEMENTS__ACCOUNT_ENTITLEMENT_CONFLICT_CHECKER__SUCCESS');
export const accountEntitlementConflictCheckerFailure = createAction<PayloadData<Error, AccountEntitlementConflictChecker$Request, true>>('ACCOUNT_ENTITLEMENTS__ACCOUNT_ENTITLEMENT_CONFLICT_CHECKER__FAILURE');

export const accountEntitlementConflictCheckerActions = [
    accountEntitlementConflictCheckerRequest,
    accountEntitlementConflictCheckerSuccess,
    accountEntitlementConflictCheckerFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {EntitlementConflictRequest} [meta.entitlementConflictRequest]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const accountEntitlementConflictChecker = (meta: AccountEntitlementConflictChecker$Request, config?: AccountEntitlementConflictChecker$Config) => {
    return {
        CALL_API: {
            types: accountEntitlementConflictCheckerActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/account/${meta.accountId}/entitlements-conflicts`,
            TRANSPORT_REQUEST_BODY: meta.entitlementConflictRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetAccountEntitlementRelations$Request {
    accountId: number;
    pageNumber: number;
    pageSize: number;
    sortDirection: SortDirection;
    resourceType?: ResourceType;
    requestBody?: Array<string>;
}

export interface GetAccountEntitlementRelations$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountEntitlementRelationsRequest = createAction<PayloadData<void, GetAccountEntitlementRelations$Request>>('ACCOUNT_ENTITLEMENTS__GET_ACCOUNT_ENTITLEMENT_RELATIONS__REQUEST');
export const getAccountEntitlementRelationsSuccess = createAction<PayloadData<RelationPage, GetAccountEntitlementRelations$Request>>('ACCOUNT_ENTITLEMENTS__GET_ACCOUNT_ENTITLEMENT_RELATIONS__SUCCESS');
export const getAccountEntitlementRelationsFailure = createAction<PayloadData<Error, GetAccountEntitlementRelations$Request, true>>('ACCOUNT_ENTITLEMENTS__GET_ACCOUNT_ENTITLEMENT_RELATIONS__FAILURE');

export const getAccountEntitlementRelationsActions = [
    getAccountEntitlementRelationsRequest,
    getAccountEntitlementRelationsSuccess,
    getAccountEntitlementRelationsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {number} meta.pageNumber
 * @param {number} meta.pageSize
 * @param {SortDirection} meta.sortDirection
 * @param {ResourceType} [meta.resourceType] Return only entitlements for resources of this type.
 * @param {Array<string>} [meta.requestBody]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountEntitlementRelations = (meta: GetAccountEntitlementRelations$Request, config?: GetAccountEntitlementRelations$Config) => {
    const TRANSPORT_GET_PARAMS = {
        pageNumber: meta.pageNumber,
        pageSize: meta.pageSize,
        sortDirection: meta.sortDirection,
        resourceType: meta.resourceType,
    };
    return {
        CALL_API: {
            types: getAccountEntitlementRelationsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/account/${meta.accountId}/entitlements`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.requestBody,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

